import { ApiService } from '../../lib/http.service';
import { env } from "../../definitions/global.vars";
export var Api = new ApiService();
export var NotificationsApi = (function () {
    return {
        get_notification: function (request) {
            return Api.start('post', 'https://notification.oley.com/get_notification/', request, true);
        },
        delete_notification: function (request) {
            return Api.start('post', env.misc_api + '/misc/api/mark-deleted-notification/', request, true);
        },
    };
})();
